import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { KeyValue } from '../models/key-value';
import { AuthenticationService } from '../services/api/auth.service';



@Injectable({
   providedIn: 'root'
})
export class AdminGuard implements CanActivate {

   /**
    * El guard es un singleton `providedIn: 'root'`: se instancia antes del login,
    * cuando todavía no hay `currentUser`. Cachear los roles en el constructor los
    * dejaba en `undefined` para el resto de la vida del guard. Se leen en cada uso.
    */
   private get roles(): Array<KeyValue> {
      const raw = localStorage.getItem('currentUser');
      return raw ? (JSON.parse(raw)?.roles ?? []) : [];
   }

   constructor(private authService: AuthenticationService, private router: Router) { }

   canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean | UrlTree {
      let url: string = state.url;
      return this.checkLogin(next, url);
   }

   checkLogin(route: ActivatedRouteSnapshot, url: string): true | UrlTree {
      let val: string = sessionStorage.getItem('accessToken');

      if (val) {
         // Token sin perfil: sesión incompleta. Sin esto la aplicación queda en un
         // estado del que no se sale (ni entra ni vuelve al login).
         if (!localStorage.getItem('currentUser'))
            return this.router.parseUrl('/login');

         if (url == "/login")
            this.router.parseUrl('/users');
         else {
            if (this.roles.filter(f => route.data.roles.includes(f.name).length > 0))
               return true;
           /*  const result = this.roles.filter(f => route.data.roles.includes(f.name));
            if (result.length > 0)
              return  true; */

         }
      } else {
         return this.router.parseUrl('/login');
      }
   }

   haveAccess(route) {
      //routes.filter(x => x.path == route)
      const result = this.roles.filter(f => route.roles.includes(f.name));
      if (result.length > 0)
         return true;
      return false;
   }

}